import Marquee from "react-fast-marquee";
import { MARQUEE } from "@/constants/testIds";

const items = [
  { text: "PREPARE", fill: true },
  { text: "PERFORM", fill: false },
  { text: "POSITION", fill: true },
  { text: "PROFIT", fill: false },
  { text: "THE WORK GONE ALWAYS SHOW", fill: true },
];

const EditorialMarquee = () => {
  return (
    <section
      data-testid={MARQUEE.root}
      className="section-rule border-y border-white/10 bg-black py-8 md:py-10 overflow-hidden"
      aria-label="Editorial marquee"
    >
      <Marquee gradient={false} speed={40} pauseOnHover>
        {items.concat(items).map((it, i) => (
          <span key={i} className="marquee-item">
            <span
              className={`font-display uppercase text-[14vw] md:text-[10vw] leading-none ${
                it.fill ? "text-white" : "stroke-text"
              }`}
            >
              {it.text}
            </span>
            <span className="text-[#FF4D00] font-display text-[10vw] md:text-[8vw]">
              ✦
            </span>
          </span>
        ))}
      </Marquee>
    </section>
  );
};

export default EditorialMarquee;
